import { createStore, compose,applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { cartReducer } from './Reducers/cartReducers';
import { productDetailsReducer, productListReducer } from './Reducers/productReducers';
import {  userRegisterReducer, userSigninReducer, otpVerificationReducer } from './Reducers/userReducers';
import { categoryListReducer } from './Reducers/categoryReducers';
import { orderCreateReducer } from './Reducers/orderReducers';

const initialState = {
    userSignin:{
        userInfo : localStorage.getItem('userInfo')
        ? JSON.parse(localStorage.getItem('userInfo'))
        :null,
    },

    cart:{
        cartItems: localStorage.getItem('cartItems')
        ? JSON.parse( localStorage.getItem('cartItems'))
        :[],
        
        shippingAddress: localStorage.getItem('shippingAddress') 
        ? JSON.parse(localStorage.getItem('shippingAddress'))
        :{},
        paymentMethod: localStorage.getItem('paymentMethod')
        ? JSON.parse(localStorage.getItem('paymentMethod'))
        : null,
    },
     
    
    
};
const reducer = combineReducers({
    productList: productListReducer,
    productDetails: productDetailsReducer,
    cart: cartReducer,
    userSignin: userSigninReducer,
    userRegister: userRegisterReducer,
    otpVerification: otpVerificationReducer,
    categoryList: categoryListReducer,
    orderCreate: orderCreateReducer,
}); 

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
   
const store = createStore(
    reducer,
    initialState,
    composeEnhancer(applyMiddleware(thunk))
    );

export default store; 